module.exports = __webpack_public_path__ + "img/maping.6c22d932.png";